<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7521_6454)">
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint0_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint1_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint2_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint3_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint4_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint5_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint6_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint7_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint8_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint9_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint10_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint11_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint12_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint13_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint14_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint15_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint16_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint17_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint18_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint19_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint20_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint21_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint22_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint23_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint24_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint25_linear_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint26_radial_7521_6454)"
      />
      <path d="M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z"
            fill="url(#paint27_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint28_linear_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint29_linear_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint30_linear_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint31_linear_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint32_linear_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint33_linear_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint34_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint35_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint36_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint37_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint38_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint39_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint40_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint41_radial_7521_6454)"
      />
      <path d="M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H18.8876C18.9683 27.8477 19.049 27.8357 19.1247 27.8075C19.2579 27.758 19.3714 27.7005 19.4816 27.5903L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z"
            fill="url(#paint42_radial_7521_6454)"
      />
      <path d="M9.52539 12.0156C9.25572 12.0156 9.03711 12.2342 9.03711 12.5039C9.03711 12.7736 9.25572 12.9922 9.52539 12.9922H22.4629C22.7326 12.9922 22.9512 12.7736 22.9512 12.5039C22.9512 12.2342 22.7326 12.0156 22.4629 12.0156H9.52539Z"
            fill="#9B96A2"
      />
      <path d="M9.52539 15.0234C9.25572 15.0234 9.03711 15.242 9.03711 15.5117C9.03711 15.7814 9.25572 16 9.52539 16H22.4629C22.7326 16 22.9512 15.7814 22.9512 15.5117C22.9512 15.242 22.7326 15.0234 22.4629 15.0234H9.52539Z"
            fill="#9B96A2"
      />
      <path d="M9.03711 18.5195C9.03711 18.2499 9.25572 18.0312 9.52539 18.0312H22.4629C22.7326 18.0312 22.9512 18.2499 22.9512 18.5195C22.9512 18.7892 22.7326 19.0078 22.4629 19.0078H9.52539C9.25572 19.0078 9.03711 18.7892 9.03711 18.5195Z"
            fill="#9B96A2"
      />
      <path d="M9.52539 21.0391C9.25572 21.0391 9.03711 21.2577 9.03711 21.5273C9.03711 21.797 9.25572 22.0156 9.52539 22.0156H17.5176C17.7872 22.0156 18.0059 21.797 18.0059 21.5273C18.0059 21.2577 17.7872 21.0391 17.5176 21.0391H9.52539Z"
            fill="#9B96A2"
      />
      <path d="M24.5004 22.223C24.6329 22.223 24.8784 22.1149 24.916 21.9102C24.9148 22.018 24.8948 22.1235 24.8576 22.223C24.8097 22.3509 24.7335 22.4686 24.6329 22.5668L19.4923 27.5821C19.4005 27.6717 19.292 27.7414 19.174 27.7884C19.098 27.8187 19.0181 27.8395 18.936 27.8502C19.0257 27.8284 19.1222 27.7651 19.1498 27.6184C19.1491 27.6034 19.1487 27.5883 19.1487 27.5731V23.1663C19.1487 22.6453 19.5816 22.223 20.1156 22.223H24.5004Z"
            fill="url(#paint43_linear_7521_6454)"
      />
      <path d="M24.5004 22.223C24.6329 22.223 24.8784 22.1149 24.916 21.9102C24.9148 22.018 24.8948 22.1235 24.8576 22.223C24.8097 22.3509 24.7335 22.4686 24.6329 22.5668L19.4923 27.5821C19.4005 27.6717 19.292 27.7414 19.174 27.7884C19.098 27.8187 19.0181 27.8395 18.936 27.8502C19.0257 27.8284 19.1222 27.7651 19.1498 27.6184C19.1491 27.6034 19.1487 27.5883 19.1487 27.5731V23.1663C19.1487 22.6453 19.5816 22.223 20.1156 22.223H24.5004Z"
            fill="url(#paint44_linear_7521_6454)"
      />
      <path d="M24.5004 22.223C24.6329 22.223 24.8784 22.1149 24.916 21.9102C24.9148 22.018 24.8948 22.1235 24.8576 22.223C24.8097 22.3509 24.7335 22.4686 24.6329 22.5668L19.4923 27.5821C19.4005 27.6717 19.292 27.7414 19.174 27.7884C19.098 27.8187 19.0181 27.8395 18.936 27.8502C19.0257 27.8284 19.1222 27.7651 19.1498 27.6184C19.1491 27.6034 19.1487 27.5883 19.1487 27.5731V23.1663C19.1487 22.6453 19.5816 22.223 20.1156 22.223H24.5004Z"
            fill="url(#paint45_linear_7521_6454)"
      />
      <path d="M24.5004 22.223C24.6329 22.223 24.8784 22.1149 24.916 21.9102C24.9148 22.018 24.8948 22.1235 24.8576 22.223C24.8097 22.3509 24.7335 22.4686 24.6329 22.5668L19.4923 27.5821C19.4005 27.6717 19.292 27.7414 19.174 27.7884C19.098 27.8187 19.0181 27.8395 18.936 27.8502C19.0257 27.8284 19.1222 27.7651 19.1498 27.6184C19.1491 27.6034 19.1487 27.5883 19.1487 27.5731V23.1663C19.1487 22.6453 19.5816 22.223 20.1156 22.223H24.5004Z"
            fill="url(#paint46_linear_7521_6454)"
      />
      <path d="M24.5004 22.223C24.6329 22.223 24.8784 22.1149 24.916 21.9102C24.9148 22.018 24.8948 22.1235 24.8576 22.223C24.8097 22.3509 24.7335 22.4686 24.6329 22.5668L19.4923 27.5821C19.4005 27.6717 19.292 27.7414 19.174 27.7884C19.098 27.8187 19.0181 27.8395 18.936 27.8502C19.0257 27.8284 19.1222 27.7651 19.1498 27.6184C19.1491 27.6034 19.1487 27.5883 19.1487 27.5731V23.1663C19.1487 22.6453 19.5816 22.223 20.1156 22.223H24.5004Z"
            fill="url(#paint47_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint48_linear_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint49_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint50_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint51_linear_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint52_linear_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint53_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint54_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint55_linear_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint56_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint57_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint58_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint59_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint60_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint61_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint62_radial_7521_6454)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z"
            fill="url(#paint63_radial_7521_6454)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7521_6454"
                      x1="16"
                      y1="3.03516"
                      x2="16"
                      y2="29.9688"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8A874" />
        <stop offset="1"
              stop-color="#DB925D"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7521_6454"
                      x1="7.19809"
                      y1="15.7241"
                      x2="6.29593"
                      y2="15.7241"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CD7D52"
              stop-opacity="0"
        />
        <stop offset="0.105083"
              stop-color="#CD7D52"
        />
        <stop offset="0.791667"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7521_6454"
                      x1="14.0515"
                      y1="27.7323"
                      x2="14.0515"
                      y2="28.5303"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CD7D52"
              stop-opacity="0"
        />
        <stop offset="0.105083"
              stop-color="#CD7D52"
        />
        <stop offset="0.791667"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint3_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(6.12531 28.7012) rotate(-45) scale(2.83035 3.66846)"
      >
        <stop offset="0.652657"
              stop-color="#DB925D"
        />
        <stop offset="1"
              stop-color="#DB925D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.6577 28.3929) rotate(-171.2) scale(8.30793 5.99282)"
      >
        <stop offset="0.856502"
              stop-color="#DB925D"
        />
        <stop offset="0.952476"
              stop-color="#DB925D"
              stop-opacity="0.291083"
        />
        <stop offset="1"
              stop-color="#DB925D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint5_linear_7521_6454"
                      x1="21.6402"
                      y1="25.2547"
                      x2="22.0726"
                      y2="25.6839"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CD7D52"
              stop-opacity="0"
        />
        <stop offset="0.105083"
              stop-color="#CD7D52"
        />
        <stop offset="0.791667"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint6_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.2424 30.3143) rotate(-88.1045) scale(2.59084 2.86135)"
      >
        <stop offset="0.856502"
              stop-color="#DB925D"
        />
        <stop offset="0.952476"
              stop-color="#DB925D"
              stop-opacity="0.291083"
        />
        <stop offset="1"
              stop-color="#DB925D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.5292 20.6486) rotate(157.353) scale(4.22011 2.40242)"
      >
        <stop offset="0.674511"
              stop-color="#DB925D"
        />
        <stop offset="0.886621"
              stop-color="#DB925D"
              stop-opacity="0.207805"
        />
        <stop offset="1"
              stop-color="#DB925D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.89124 26.9305) rotate(149.534) scale(1.56937 1.72924)"
      >
        <stop offset="0.429764"
              stop-color="#CD7D52"
        />
        <stop offset="0.791667"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.5485 26.5518) rotate(63.7833) scale(2.21903 1.94197)"
      >
        <stop offset="0.603005"
              stop-color="#CD7D52"
        />
        <stop offset="0.711247"
              stop-color="#CD7D52"
              stop-opacity="0.395219"
        />
        <stop offset="0.79003"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.6502 22.7297) rotate(179.474) scale(4.32756 9.16762)"
      >
        <stop stop-color="#E8A874" />
        <stop offset="0.661458"
              stop-color="#E8A874"
              stop-opacity="0.177083"
        />
        <stop offset="1"
              stop-color="#E8A874"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.266 17.1282) rotate(121.449) scale(4.772 10.1091)"
      >
        <stop stop-color="#E8A874" />
        <stop offset="0.661458"
              stop-color="#E8A874"
              stop-opacity="0.177083"
        />
        <stop offset="1"
              stop-color="#E8A874"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint12_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.18189 3.30688) rotate(76.0366) scale(3.11511 6.59912)"
      >
        <stop stop-color="#E8A874" />
        <stop offset="0.744173"
              stop-color="#E8A874"
        />
        <stop offset="1"
              stop-color="#E8A874"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.6855 5.3125) rotate(-90) scale(2.5 2.02864)"
      >
        <stop stop-color="#D79769" />
        <stop offset="1"
              stop-color="#D79769"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.97908 6.24383) rotate(-120.619) scale(1.37751 1.3826)"
      >
        <stop offset="0.595767"
              stop-color="#CD7D52"
        />
        <stop offset="0.800492"
              stop-color="#CD7D52"
              stop-opacity="0.395219"
        />
        <stop offset="0.906903"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint15_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.80388 5.62457) rotate(-90) scale(0.778532 1.73673)"
      >
        <stop offset="0.527329"
              stop-color="#CD7D52"
        />
        <stop offset="0.739134"
              stop-color="#CD7D52"
              stop-opacity="0.395219"
        />
        <stop offset="0.858764"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint16_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.0801 5.52398) rotate(-90) scale(0.627459 1.73214)"
      >
        <stop offset="0.527329"
              stop-color="#CD7D52"
        />
        <stop offset="0.739134"
              stop-color="#CD7D52"
              stop-opacity="0.395219"
        />
        <stop offset="0.858764"
              stop-color="#CD7D52"
              stop-opacity="0.116398"
        />
        <stop offset="1"
              stop-color="#CD7D52"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint17_linear_7521_6454"
                      x1="15.2246"
                      y1="3.0377"
                      x2="15.2246"
                      y2="3.8334"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC287" />
        <stop offset="0.797338"
              stop-color="#FFC287"
              stop-opacity="0.133148"
        />
        <stop offset="1"
              stop-color="#FFC287"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7521_6454"
                      x1="26.9277"
                      y1="15.5486"
                      x2="26.2109"
                      y2="15.5486"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC287" />
        <stop offset="0.776079"
              stop-color="#FFC287"
              stop-opacity="0.114357"
        />
        <stop offset="1"
              stop-color="#FFC287"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7521_6454"
                      x1="16"
                      y1="30.3397"
                      x2="16"
                      y2="29.175"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0882706"
              stop-color="#A4545D"
        />
        <stop offset="0.823892"
              stop-color="#A4545D"
              stop-opacity="0.12"
        />
        <stop offset="1"
              stop-color="#A4545D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7521_6454"
                      x1="4.88649"
                      y1="16.502"
                      x2="5.7299"
                      y2="16.502"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A4545D" />
        <stop offset="0.787277"
              stop-color="#A4545D"
              stop-opacity="0.12292"
        />
        <stop offset="1"
              stop-color="#A4545D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint21_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.41169 29.6258) rotate(-48.7591) scale(34.9222 19.3869)"
      >
        <stop offset="0.53417"
              stop-color="#FFC287"
              stop-opacity="0"
        />
        <stop offset="0.954962"
              stop-color="#FFC287"
              stop-opacity="0"
        />
        <stop offset="0.968283"
              stop-color="#FFC287"
              stop-opacity="0.093854"
        />
        <stop offset="0.97518"
              stop-color="#FFC287"
              stop-opacity="0.269784"
        />
        <stop offset="0.984482"
              stop-color="#FFC287"
              stop-opacity="0.56"
        />
        <stop offset="0.994408"
              stop-color="#FFC287"
              stop-opacity="0.83"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.7372 10.8567) rotate(130.872) scale(25.0468 17.7661)"
      >
        <stop offset="0.53417"
              stop-color="#A4545D"
              stop-opacity="0"
        />
        <stop offset="0.954962"
              stop-color="#A4545D"
              stop-opacity="0"
        />
        <stop offset="0.963192"
              stop-color="#A4545D"
              stop-opacity="0.093854"
        />
        <stop offset="0.971887"
              stop-color="#A4545D"
              stop-opacity="0.269784"
        />
        <stop offset="0.983579"
              stop-color="#A4545D"
              stop-opacity="0.56"
        />
        <stop offset="1"
              stop-color="#A4545D"
              stop-opacity="0.83"
        />
      </radialGradient>
      <radialGradient id="paint23_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1.44676 31.1015) rotate(-47.6345) scale(37.2595 19.9715)"
      >
        <stop offset="0.53417"
              stop-color="#D08F65"
              stop-opacity="0"
        />
        <stop offset="0.990296"
              stop-color="#D08F65"
              stop-opacity="0"
        />
        <stop offset="0.994174"
              stop-color="#D08F65"
              stop-opacity="0.093854"
        />
        <stop offset="0.996487"
              stop-color="#D08F65"
              stop-opacity="0.36"
        />
        <stop offset="0.999217"
              stop-color="#D08F65"
              stop-opacity="0.83"
        />
      </radialGradient>
      <linearGradient id="paint24_linear_7521_6454"
                      x1="16"
                      y1="3.03516"
                      x2="16"
                      y2="3.2464"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D08F65" />
        <stop offset="0.786458"
              stop-color="#D08F65"
              stop-opacity="0.114583"
        />
        <stop offset="1"
              stop-color="#D08F65"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7521_6454"
                      x1="26.9277"
                      y1="16.7031"
                      x2="26.7928"
                      y2="16.7031"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D08F65" />
        <stop offset="0.796875"
              stop-color="#D08F65"
              stop-opacity="0.09375"
        />
        <stop offset="1"
              stop-color="#D08F65"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint26_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.8594 4.0625) rotate(158.888) scale(0.241248 2.03218)"
      >
        <stop stop-color="#D08F65" />
        <stop offset="0.796875"
              stop-color="#D08F65"
              stop-opacity="0.09375"
        />
        <stop offset="1"
              stop-color="#D08F65"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint27_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.8837 3.06969) rotate(113.963) scale(0.303826 2.55932)"
      >
        <stop stop-color="#D08F65" />
        <stop offset="0.796875"
              stop-color="#D08F65"
              stop-opacity="0.09375"
        />
        <stop offset="1"
              stop-color="#D08F65"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint28_linear_7521_6454"
                      x1="15.9902"
                      y1="5.15625"
                      x2="15.9902"
                      y2="27.8477"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAE2F4" />
        <stop offset="1"
              stop-color="#E4DAEF"
        />
      </linearGradient>
      <linearGradient id="paint29_linear_7521_6454"
                      x1="15.9902"
                      y1="5.15625"
                      x2="15.9902"
                      y2="5.67294"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="0.75044"
              stop-color="#FFFFFF"
              stop-opacity="0.163437"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint30_linear_7521_6454"
                      x1="25.0116"
                      y1="15.6024"
                      x2="24.3615"
                      y2="15.6024"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.213542"
              stop-color="#FFFFFF"
        />
        <stop offset="0.77495"
              stop-color="#FFFFFF"
              stop-opacity="0.14863"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint31_linear_7521_6454"
                      x1="6.98906"
                      y1="16.502"
                      x2="7.62294"
                      y2="16.502"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0790508"
              stop-color="#CAB8DC"
        />
        <stop offset="0.722078"
              stop-color="#CAB8DC"
              stop-opacity="0.150656"
        />
        <stop offset="1"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint32_linear_7521_6454"
                      x1="13.7437"
                      y1="27.9796"
                      x2="13.7437"
                      y2="27.28"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.325014"
              stop-color="#CAB8DC"
        />
        <stop offset="0.707064"
              stop-color="#CAB8DC"
              stop-opacity="0.262727"
        />
        <stop offset="1"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint33_linear_7521_6454"
                      x1="7.33972"
                      y1="27.6758"
                      x2="7.50769"
                      y2="27.2187"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CAB8DC" />
        <stop offset="1"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint34_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.4452 26.0988) rotate(-176.952) scale(1.26866 4.03664)"
      >
        <stop stop-color="#CAB8DC" />
        <stop offset="0.706917"
              stop-color="#CAB8DC"
              stop-opacity="0.116368"
        />
        <stop offset="1"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint35_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.7431 23.2423) rotate(-161.209) scale(1.12464)"
      >
        <stop stop-color="#CAB8DC" />
        <stop offset="0.803021"
              stop-color="#CAB8DC"
              stop-opacity="0.116368"
        />
        <stop offset="1"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint36_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.5269 24.4073) rotate(179.021) scale(1.16767 2.01745)"
      >
        <stop stop-color="#CAB8DC" />
        <stop offset="0.706917"
              stop-color="#CAB8DC"
              stop-opacity="0.116368"
        />
        <stop offset="1"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint37_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.6003 5.63272) rotate(128.311) scale(27.8594 18.2012)"
      >
        <stop offset="0.957987"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
        <stop offset="0.972569"
              stop-color="#CAB8DC"
              stop-opacity="0.180975"
        />
        <stop offset="0.996603"
              stop-color="#CAB8DC"
        />
      </radialGradient>
      <radialGradient id="paint38_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.51074 27.5533) rotate(-52.5073) scale(27.7798 17.9893)"
      >
        <stop offset="0.957987"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.973458"
              stop-color="#FFFFFF"
              stop-opacity="0.180975"
        />
        <stop offset="0.984218"
              stop-color="#FFFFFF"
              stop-opacity="0.359888"
        />
        <stop offset="0.996603"
              stop-color="#FFFFFF"
        />
      </radialGradient>
      <radialGradient id="paint39_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.4299 26.0949) rotate(-132.683) scale(28.3906 18.5482)"
      >
        <stop offset="0.960701"
              stop-color="#CAB8DC"
              stop-opacity="0"
        />
        <stop offset="0.97115"
              stop-color="#CAB8DC"
              stop-opacity="0.180975"
        />
        <stop offset="0.989089"
              stop-color="#CAB8DC"
        />
      </radialGradient>
      <radialGradient id="paint40_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.9086 22.6146) rotate(-90) scale(0.86671 3.10665)"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="0.791858"
              stop-color="#FFFFFF"
              stop-opacity="0.138217"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint41_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.6987 22.28) rotate(-90) scale(0.590615 4.15825)"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="0.791858"
              stop-color="#FFFFFF"
              stop-opacity="0.138217"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint42_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.344 22.5358) rotate(-90) scale(0.720383 1.24941)"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="0.824494"
              stop-color="#FFFFFF"
              stop-opacity="0.16795"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint43_linear_7521_6454"
                      x1="19.1727"
                      y1="23.414"
                      x2="21.4037"
                      y2="26.0919"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D9D1E3" />
        <stop offset="0.900635"
              stop-color="#C8BDD3"
        />
      </linearGradient>
      <linearGradient id="paint44_linear_7521_6454"
                      x1="21.926"
                      y1="22.058"
                      x2="21.926"
                      y2="23.0921"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.140064"
              stop-color="#DDD9E1"
        />
        <stop offset="0.834955"
              stop-color="#DDD9E1"
              stop-opacity="0.0795198"
        />
        <stop offset="1"
              stop-color="#DDD9E1"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint45_linear_7521_6454"
                      x1="22.1299"
                      y1="25.1875"
                      x2="21.8511"
                      y2="24.9055"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0993291"
              stop-color="#AFA5BA"
        />
        <stop offset="0.718496"
              stop-color="#AFA5BA"
              stop-opacity="0.168543"
        />
        <stop offset="1"
              stop-color="#AFA5BA"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint46_linear_7521_6454"
                      x1="19.0864"
                      y1="25.2486"
                      x2="19.521"
                      y2="25.2486"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AFA5BA" />
        <stop offset="0.72189"
              stop-color="#AFA5BA"
              stop-opacity="0.173819"
        />
        <stop offset="0.854167"
              stop-color="#AFA5BA"
              stop-opacity="0.0618489"
        />
        <stop offset="1"
              stop-color="#AFA5BA"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint47_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-3.59677 -3.20659 3.39413 -3.62391 22.8517 25.4909)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.29098"
              stop-color="#AFA5BA"
              stop-opacity="0"
        />
        <stop offset="0.865449"
              stop-color="#AFA5BA"
              stop-opacity="0"
        />
        <stop offset="0.895787"
              stop-color="#AFA5BA"
              stop-opacity="0.125865"
        />
        <stop offset="0.909629"
              stop-color="#AFA5BA"
              stop-opacity="0.173819"
        />
        <stop offset="0.987134"
              stop-color="#AFA5BA"
        />
      </radialGradient>
      <linearGradient id="paint48_linear_7521_6454"
                      x1="18.7168"
                      y1="3.78125"
                      x2="15.6543"
                      y2="8.21875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#948A94" />
        <stop offset="1"
              stop-color="#8D8291"
        />
      </linearGradient>
      <radialGradient id="paint49_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.9892 3.95136) rotate(-75.0499) scale(2.00269)"
      >
        <stop offset="0.831658"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
        <stop offset="0.881911"
              stop-color="#ACA6AB"
              stop-opacity="0.32395"
        />
        <stop offset="0.924879"
              stop-color="#ACA6AB"
              stop-opacity="0.724041"
        />
        <stop offset="0.987826"
              stop-color="#ACA6AB"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint50_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.6065 6.58382) rotate(-55.4455) scale(2.78872 2.53152)"
      >
        <stop offset="0.831658"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
        <stop offset="0.881911"
              stop-color="#ACA6AB"
              stop-opacity="0.32395"
        />
        <stop offset="0.924879"
              stop-color="#ACA6AB"
              stop-opacity="0.724041"
        />
        <stop offset="0.987826"
              stop-color="#ACA6AB"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint51_linear_7521_6454"
                      x1="18.7168"
                      y1="3.78125"
                      x2="15.6543"
                      y2="8.21875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000399304"
              stop-color="#948A94"
              stop-opacity="0"
        />
        <stop offset="0.124367"
              stop-color="#948A94"
        />
        <stop offset="1"
              stop-color="#8D8291"
        />
      </linearGradient>
      <linearGradient id="paint52_linear_7521_6454"
                      x1="15.5669"
                      y1="8.03487"
                      x2="15.5669"
                      y2="7.67301"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8E8092" />
        <stop offset="0.4599"
              stop-color="#8E8092"
        />
        <stop offset="1"
              stop-color="#8E8092"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint53_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.8928 4.03055) rotate(-135) scale(1.07195)"
      >
        <stop offset="0.772789"
              stop-color="#ACA6AB"
        />
        <stop offset="0.923796"
              stop-color="#ACA6AB"
              stop-opacity="0.19"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint54_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.3906 3.51562) rotate(132.879) scale(0.927941 0.753951)"
      >
        <stop stop-color="#ACA6AB" />
        <stop offset="0.194301"
              stop-color="#ACA6AB"
        />
        <stop offset="0.821884"
              stop-color="#ACA6AB"
              stop-opacity="0.132695"
        />
        <stop offset="0.871628"
              stop-color="#ACA6AB"
              stop-opacity="0.0654085"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint55_linear_7521_6454"
                      x1="20.9454"
                      y1="6.2643"
                      x2="20.6328"
                      y2="6.2643"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ACA6AB" />
        <stop offset="0.626321"
              stop-color="#ACA6AB"
              stop-opacity="0.222234"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint56_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.0625 3.89844) rotate(-90) scale(1.08919)"
      >
        <stop stop-color="#8E8092" />
        <stop offset="0.813394"
              stop-color="#8E8092"
        />
        <stop offset="1"
              stop-color="#8E8092"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint57_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.2627 2.84115) rotate(41.8227) scale(0.40224 1.05833)"
      >
        <stop stop-color="#8E8092" />
        <stop offset="0.494582"
              stop-color="#8E8092"
              stop-opacity="0.932292"
        />
        <stop offset="0.838542"
              stop-color="#8E8092"
              stop-opacity="0.172931"
        />
        <stop offset="1"
              stop-color="#8E8092"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint58_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.9336 2.15625) rotate(66.6022) scale(0.442649 1.16465)"
      >
        <stop stop-color="#8E8092" />
        <stop offset="0.494582"
              stop-color="#8E8092"
              stop-opacity="0.932292"
        />
        <stop offset="0.838542"
              stop-color="#8E8092"
              stop-opacity="0.172931"
        />
        <stop offset="1"
              stop-color="#8E8092"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint59_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.6133 3.96484) rotate(88.6935) scale(0.224848 0.720518)"
      >
        <stop stop-color="#ACA6AB"
              stop-opacity="0.82"
        />
        <stop offset="0.396971"
              stop-color="#ACA6AB"
              stop-opacity="0.636364"
        />
        <stop offset="0.807797"
              stop-color="#ACA6AB"
              stop-opacity="0.125"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint60_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.993 3.9095) rotate(85.0303) scale(0.300804 1.13989)"
      >
        <stop stop-color="#ACA6AB" />
        <stop offset="0.458338"
              stop-color="#ACA6AB"
              stop-opacity="0.636364"
        />
        <stop offset="0.807797"
              stop-color="#ACA6AB"
              stop-opacity="0.125"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint61_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.4008 4.0307) rotate(69.3011) scale(0.330075 1.25081)"
      >
        <stop stop-color="#ACA6AB" />
        <stop offset="0.458338"
              stop-color="#ACA6AB"
              stop-opacity="0.636364"
        />
        <stop offset="0.807797"
              stop-color="#ACA6AB"
              stop-opacity="0.125"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint62_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.9432 4.21275) rotate(51.7091) scale(0.327459 2.34411)"
      >
        <stop stop-color="#ACA6AB" />
        <stop offset="0.458338"
              stop-color="#ACA6AB"
              stop-opacity="0.636364"
        />
        <stop offset="0.807797"
              stop-color="#ACA6AB"
              stop-opacity="0.125"
        />
        <stop offset="1"
              stop-color="#ACA6AB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint63_radial_7521_6454"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.0859 3.52344) rotate(8.55039) scale(0.281842 0.741551)"
      >
        <stop stop-color="#8E8092" />
        <stop offset="0.494582"
              stop-color="#8E8092"
              stop-opacity="0.932292"
        />
        <stop offset="0.838542"
              stop-color="#8E8092"
              stop-opacity="0.172931"
        />
        <stop offset="1"
              stop-color="#8E8092"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_7521_6454">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>